import Vue from 'vue';
import App from './App.vue';
import router from './router';
import CONFIG from './config.js';
import axios from './axios';
import 'amfe-flexible';
import 'normalize.css';
import { Toast, Dialog } from 'vant';
import { isNativeEnv, callbackFromNative, triggerInteraction, patternPrint } from '@lutong/h5-utils';
import '@lutong/h5-utils/eventEmitter';
import { setNavigationHidden } from './utils/webview';

patternPrint('Environment:', process.env.NODE_ENV);
patternPrint('Api:', process.env.VUE_APP_API);

// Vant toast、dialog 引入为全局提示，可以直接在组件中通过 this.$toast this.$dialog使用
Vue.use(Toast);
Vue.use(Dialog);

Vue.config.productionTip = true;
// 配置Vue.config.ignoredElements来忽略Vue对开放标签的检查。
Vue.config.ignoredElements = ['wx-open-launch-app'];
Vue.prototype.$config = CONFIG;
Vue.prototype.$axios = axios;
Vue.prototype.$userInfo = {};

const EventBus = new EventEmitter();
Vue.prototype.$eventBus = EventBus;

// 注册回调触发事件
window.callbackFromNative = callbackFromNative;
// 将播放回调注册给eventBus
window.PlayerCallback = {
	onStart() {
		EventBus.emit('playerOnstart');
	},
	onError() {
		EventBus.emit('playerOnerror');
	},
	onCompletion() {
		EventBus.emit('playerOncompletion');
	}
};
// 将音效回调注册给eventBus
// TODO: 事件待完善
window.EffectCallback = {
	onError() {
		EventBus.emit('effectOnerror');
	}
};

// TODO: IOS背景音回调
EventBus.on('PlayerOnStart', () => {
  EventBus.emit('playerOnstart');
});
EventBus.on('PlayerOnError', () => {
	EventBus.emit('playerOnerror');
});
EventBus.on('PlayerOnCompletion', () => {
	EventBus.emit('playerOncompletion');
});

if (isNativeEnv()) {
  // 激活webview导航栏
  setNavigationHidden(false);

	Vue.prototype.$eventBus.on('baseInfo', (data) => {
		Vue.prototype.$baseInfo = data;
		Vue.prototype.$config.APP_CODE = data.appCode;
		init();
	});

	triggerInteraction({
		type: 'baseInfo',
		data: {}
	});
} else {
	Vue.prototype.$baseInfo = {};
	init();
}

// 全局filters
// 拼接图片前缀
Vue.filter('prefixImgUrl', function(val) {
	if (!val) return '';
	return val.indexOf('http') > -1 ? val : CONFIG.RESOURCE_PATH + val;
});

// 路由钩子，动态修改页面的标题
router.beforeEach((to, from, next) => {
	if (to.meta && to.meta.title) {
		document.title = to.meta.title;
	} else {
		document.title = '';
	}
	next();
});

// 封装一层，变为等token获取后再初始化
async function init() {
	await axios.post('isg/token').then((res) => {
		axios.defaults.headers.common['Authorization'] = res.data;
	});

	// 暴露到全局，以备之后调试使用
	window._vm = new Vue({
		router,
		render: (h) => h(App)
	}).$mount('#app');
}
